import {Component, Inject, OnInit} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {AlertService, AuthenticationService, TenantService, UserService,} from '../../_services/index';
import {DOCUMENT} from "@angular/common";
import {LoginHelper} from "../../helpers";

@Component({
    standalone: false,
  selector: "forgot-password-component",
  templateUrl: 'forgot.password.component.html',
})

export class ForgotPasswordComponent implements OnInit {

  model: any = {};
  loading = false;
  emailAddress: string;
  user: any;
  checkUserAnswers: boolean;
  secretAnswer1: string;
  secretAnswer2: string;
  secretAnswer3: string;
  actionButtonName: string;
  msg: string;
  returned = false;

  selectedTenant: string;
  currentTenant: string;

  constructor(
    @Inject(DOCUMENT) public document,
    public router: Router,
    public userService: UserService,
    public authenticationService: AuthenticationService,
    public route: ActivatedRoute,
    public tenantService: TenantService,
    public alertService: AlertService) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(t => {
      const restorePasswordKey = t['restorePasswordKey'];

      if (restorePasswordKey)
      {
        this.returned = true;
        this.userService.updatePassword(restorePasswordKey, t['tenantName']).subscribe(
          data => {
            this.loading = false;
            this.checkUserAnswers = false;

            this.alertService.success('Thank You.  Your password will be emailed to your shortly.', false);
          },
          error => {
            const errorMessage = 'Failed to reset email';
            this.msg = errorMessage;
            this.loading = false;
          });
      }
    });

    this.checkUserAnswers = false;

    this.currentTenant = this.selectedTenant = LoginHelper.getTenantNameFromUrl();

    this.actionButtonName = "Verify";
  }

  onChangePassword() {
    this.loading = true;



    this.userService.getByEmail(this.emailAddress, this.selectedTenant)
      .subscribe(
        data => {

          this.user = data;
          this.user.tenantName = this.selectedTenant;
          this.checkUserAnswers = true;
          this.actionButtonName = "Send password";

          this.userService.sendRestorePasswordEmail(this.user).subscribe(
            data => {
              this.loading = false;
              this.checkUserAnswers = false;

              this.alertService.success('Message with reset password instructions was sent to your email', false);
            },
            error => {
              const errorMessage = 'Failed to sent email';
              this.msg = errorMessage;
              this.loading = false;
            });
        },
        error => {
          const errorMessage = 'The e-mail that you have entered is invalid.';
          this.msg = errorMessage;
          this.loading = false;
        });
  }
}
